import { render, staticRenderFns } from "./reportdepartmentsum.vue?vue&type=template&id=4d389912&"
import script from "./reportdepartmentsum.vue?vue&type=script&lang=js&"
export * from "./reportdepartmentsum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports